const getImageIndexWithFlag = (images, flag) => {
  if (images === null || images.length === 0) {
    return []
  }

  const reducer = (accumulator, currentElement, currentIndex) => {
    const imageName = currentElement.src.match('[^_]+$')
    if (imageName !== null && imageName[0].charAt(0) === flag) {
      accumulator.push(currentIndex)
    }
    return accumulator
  }

  return images.reduce(reducer, [])
}

export default getImageIndexWithFlag
